import { ColDef } from 'ag-grid-community';
import { Badge } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { appRoute } from 'app/railways/router/routes';

import { TTrip } from '../../../core/trips';
import { END_TIME_FILTER_NAME, START_TIME_FILTER_NAME } from '../local-params';

export const manageTripsCols: ColDef[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const routePath = appRoute.TRIP.buildPath({ id: value });

      return <Link to={routePath}>{value}</Link>;
    },
  },
  {
    field: 'blocked',
    headerName: 'Статус',
    sortable: true,
    minWidth: 150,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: boolean }) => {
      switch (value) {
        case true:
          return (
            <Badge
              status="error"
              text="Заблокирован"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case false:
          return (
            <Badge
              status="success"
              text="Активен"
              style={{ whiteSpace: 'nowrap' }}
            />
          );

        default:
          return <span>???</span>;
      }
    },
  },
  {
    field: 'route.number',
    headerName: 'Номер маршрута',
    sortable: true,
    colId: 'routeNumber',
    comparator: () => 0,
  },
  {
    field: 'route.nameRu',
    headerName: 'Маршрут',
    minWidth: 180,
    sortable: true,
    colId: 'route',
    comparator: () => 0,
  },
  {
    field: 'trainType.nameRu',
    headerName: 'Тип состава',
    sortable: true,
    colId: 'trainType',
    comparator: () => 0,
  },
  {
    field: START_TIME_FILTER_NAME,
    headerName: 'Начальное время',
    valueFormatter: ({ value }) => new Date(value).toLocaleString(),
    sortable: true,
    comparator: () => 0,
  },
  {
    field: END_TIME_FILTER_NAME,
    headerName: 'Конечное время',
    valueFormatter: ({ value }) => new Date(value).toLocaleString(),
    sortable: true,
    comparator: () => 0,
  },
  {
    field: 'refundStopDelay',
    headerName: 'Закрытие возврата',
    valueFormatter: ({ value, data }) => {
      if (!data) return '';

      const startRouteDate = moment(data.startTime);

      const final = startRouteDate.add(value, 'minutes');
      const result = final.toDate().toLocaleString();

      return result;
    },
  },
  {
    field: 'salesStopDelay',
    headerName: 'Закрытие продаж',
    sortable: true,
    comparator: () => 0,
    valueFormatter: ({ value, data }) => {
      if (!data) return '';

      const startRouteDate = moment(data.startTime);
      const final = startRouteDate.add(value, 'minutes');
      const result = final.toDate().toLocaleString();

      return result;
    },
  },
  {
    field: 'details',
    // type: 'rightAligned',
    headerName: 'Подробнее',
    // headerCheckboxSelection: true,
    cellRenderer: ({ data }: { data?: TTrip }) => {
      if (!data) return null;
      const routePath = appRoute.TRIP.buildPath({ id: data.id });

      return <Link to={routePath}>Открыть</Link>;
    },
  },
];
